import { Component } from '@angular/core';

@Component({
  selector: 'wpro-laboratory',
  template: `
    <div class="fdx-c-tabs  fdx-c-tabs--underline">
      <ul class="fdx-c-tabs__list" role="tablist">
        <li role="presentation" class="fdx-c-tabs__list-item">
          <a routerLink="/laboratory/toast" class="" role="tab" routerLinkActive="active">Toast</a>
          <a routerLink="/laboratory/modal" role="tab" routerLinkActive="active">Modal</a>
          <a routerLink="/laboratory/2fa" role="tab" routerLinkActive="active">Two Factor</a>
        </li>
      </ul>
    </div>
    <section role="tabpanel" class="fdx-c-tabs__content">
      <router-outlet></router-outlet>
    </section>
  `,
  styles: [
    '.fdx-c-tabs--underline .active {border-bottom: solid #4d148c 4px;}'
  ],
  standalone:false
})

export class LaboratoryComponent { }
